import { Routes, Route } from "react-router-dom";
import { CampaignComparison } from "./index";

export default function CampaignComparisonRoutes() {
  return (
    <Routes>
      <Route path="/" element={<CampaignComparison />} />
      <Route path="/:type/:code" element={<CampaignComparison />} />
    </Routes>
  );
}
